import React from 'react'
import { AiFillLock } from 'react-icons/ai'
import {HiOutlineCurrencyDollar, HiSparkles} from "react-icons/hi2"
import {GiFlexibleStar} from "react-icons/gi"
import {BiTimer} from "react-icons/bi"
import { Link } from 'react-router-dom'
import { FaHandPointDown } from 'react-icons/fa'
import Testimonials from '../testimonials/Testimonials'

const LandingPage = (props) => {
  return (
    <div className='landing-page'>
        <div className="about-us">
            <h2>
                Why use
                <p>Shoptinga?</p>
            </h2>
            <p>
                Shoptinga is an innovative platform that allows users to buy and sell digital products with ease. What sets Shoptinga apart from othersimilar platforms is that it offers the flexibility to use both cryptocurrency and fiat currency as a means of payment. This means that users can enjoy a more secure and seamless payment process regardless of their preferred method of payment.
            </p>
            <Link onClick={()=>{
                props.handleLoader(true, true)
            }} to={"/signup"}>
                Sign Up to Get Started
            </Link>
        </div>

        <div className="features">
            <div className="feature">
                <HiOutlineCurrencyDollar />
                <h3>
                Seamless Crypto and Fiat Transactions
                </h3>
                <p>
                ShopTinga streamlines the buying and selling process by seamlessly integrating cryptocurrency and fiat payments.
                </p>
            </div>
            <div className="feature">
                <AiFillLock size={17} style={{
                    padding: "10px"
                }}/>
                <h3>Secure and Convenient Payments</h3>
                <p>Enjoy peace of mind with ShopTinga's secure payment options, including cryptocurrencies and fiat money.</p>
            </div>
            <div className="feature">
                <GiFlexibleStar  style={{
                    padding: "10px"
                }}/>
                <h3>Flexible Payment Methods</h3>
                <p>ShopTinga provides customers with ultimate flexibility by accepting various payment methods, including cryptocurrencies and fiat money.</p>
            </div>
            <div className="feature">
                <BiTimer  style={{
                    padding: "10px"
                }}/>
                <h3>Convenience Meets Choice</h3>
                <p>
                Experience ultimate convenience with ShopTinga's extensive range of payment options, catering to your diverse preferences and needs.
                </p>
            </div>
            <div className="arrow">
            </div>
        </div>

        <div className='testimonial-h2'>
            <div className="testi">
                <h2>
                    Testimonials
                </h2>
            </div>
            <Testimonials />
        </div>
        <div className="purchase-top">
            <div className="heading">
                <h1>
                    <HiSparkles />
                    We Prioritize <span>Quality!!</span>
                </h1>
            </div>
            <div className="second">
                <img src="./quality.jpg" alt="assurance" />
                <div className="text">
                    <p>
                        At Shoptinga, we prioritize customer safety and reliability. Through rigorous product vetting, secure transactions, and dedicated support, we create a trustworthy marketplace where customers can confidently find safe and reliable digital products.

                    </p>
                    <span>
                        View our Privacy Policy to get more info <FaHandPointDown />
                    </span>

                    <a href="#!">
                        Privacy Policy
                    </a>
                </div>
            </div>
        </div>
    </div>
  )
}

export default LandingPage